import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";
import { AddNewTransporationModal } from "molecules/Modals/AddNewTransporationModal";

const Transportations = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/nearbytransvalues/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, nearbyTransId }) => {
          try {
            const reqData = { name, nearbyTransId };
            const { data } = await api("/nearbytransvalues/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, { name, nearbyTransId }) => {
          try {
            const reqData = { name, nearbyTransId };
            const { data } = await api(`/nearbytransvalues/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/nearbytransvalues/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Transportation"
      addRecord="Add Transportation"
      searchRecord="Search Transportation"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Type",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
          {
            render: (record) => <td>{record?.nearbyTransName}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{
        title: "Transportation",
        CustomModal: AddNewTransporationModal,
      }}
    />
  );
};

export default Transportations;
